<template>
  <video
    ref="video"
    class="i-video"
    :loop="loop"
    :controls="controls"
    :autoplay="autoplay"
    :muted="muted"
    controlslist="nodownload"
    playsinline
    disablepictureinpicture
    disableremoteplayback
    x-webkit-airplay="deny"
    v-on="customListeners"
    @ended="$emit('ended', $event)"
    @play="onTogglePause"
    @pause="onTogglePause"
    @seeking="onSeeking"
    @volumechange="onVolumeChange"
  >
    <source
      :src="url"
      type="video/mp4"
    >
  </video>
</template>
<script>
let videoEle
export default {
  name: 'IVideo',
  props: {
    url: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    volume: {
      type: Number,
      default: 1
    },
    currentTime: {
      type: Number,
      default: 0
    },
    muted: {
      type: Boolean,
      default: false
    },
    paused: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: true
    },
    customListeners: {
      type: Object,
      default: null
    }
  },
  watch: {
    volume: 'setVolume',
    currentTime: 'setCurrentTime',
    paused: 'togglePause',
    muted: 'ensurePlayState'
  },
  mounted () {
    // sync state when first mount
    this.setCurrentTime()
    this.setVolume()
    this.togglePause()
    videoEle = this.$refs.video
  },
  beforeDestroy () {
    // html video element still exist event not rendered in DOM. set src to empty to stop continuing playing
    if (videoEle) videoEle.src = ''
  },
  methods: {
    onTogglePause () {
      const video = this.$refs.video
      if (video == null) return // pause event get fired when video is removed but dom doesnt exist
      if (video.ended) return // pause event get fired when video is ended
      this.$emit('toggle-pause', {
        paused: video.paused,
        currentTime: video.currentTime
      })
    },
    onVolumeChange () {
      const video = this.$refs.video
      if (this.muted !== video.muted) {
        this.$emit('toggle-muted', { muted: video.muted, volume: video.volume })
      } else {
        this.$emit('volume-change', { volume: video.volume })
      }
    },
    onSeeking () {
      this.$emit('seeking', { currentTime: this.$refs.video.currentTime })
    },

    togglePause () {
      if (this.paused) {
        this.$refs.video.pause()
      } else {
        this.$refs.video.play().catch(() => {
          // to play on mobile safari without user play first, the video must be muted
          this.$refs.video.muted = true
          this.$refs.video.play()
        })
      }
    },
    setCurrentTime () {
      this.$refs.video.currentTime = this.currentTime
    },
    setVolume () {
      this.$refs.video.volume = this.volume
    },
    // on ios safari, when muted changed from true to false, if the video is playing, it will stop
    ensurePlayState (muted) {
      if (muted === true) return // this case happend on muted changed from false to true
      this.$nextTick(() => {
        if (this.paused !== this.$refs.video.paused) {
          this.$refs.video.muted = true
          this.$refs.video.play()
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.i-video {
  width: 100%
  max-height: 100%;
  display: block
}

</style>
